export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "NZD" | "USD"

export interface MarketData {
  market: string
  currencyCode: Currency
  currencySymbol: string
  locale: string
  name: string
}

export const marketsData: MarketData[] = [
  {
    market: "au",
    currencyCode: "AUD",
    currencySymbol: "AU$",
    locale: "en",
    name: "Australia",
  },
  {
    market: "ca",
    currencyCode: "CAD",
    currencySymbol: "CA$",
    locale: "en",
    name: "Canada",
  },
  {
    market: "ch",
    currencyCode: "CHF",
    currencySymbol: "CHF",
    locale: "en",
    name: "Switzerland",
  },
  {
    // German pilot market (DEV-9539). EUR like `eu`, but `locale: "de"` is the
    // real signal that drives German content + `de-DE` formatting. German
    // visitors route here via the geo flip in `I18n.getMarketFromCountry`.
    market: "de",
    currencyCode: "EUR",
    currencySymbol: "€",
    locale: "de",
    name: "Germany",
  },
  {
    market: "eu",
    currencyCode: "EUR",
    currencySymbol: "€",
    locale: "en",
    name: "Europe",
  },
  {
    market: "gb",
    currencyCode: "GBP",
    currencySymbol: "£",
    locale: "en",
    name: "United Kingdom",
  },
  {
    market: "global",
    currencyCode: "USD",
    currencySymbol: "$",
    locale: "en",
    name: "Global",
  },
  {
    market: "nz",
    currencyCode: "NZD",
    currencySymbol: "NZ$",
    locale: "en",
    name: "New Zealand",
  },
  {
    market: "us",
    currencyCode: "USD",
    currencySymbol: "$",
    locale: "en",
    name: "United States",
  },
]

/**
 * Glyph for an ISO 4217 code — the repo's own currency symbols, which `Intl`
 * must never be trusted to supply (DEV-9893: it renders AUD as `A$`, or as a
 * bare `$` under `en-AU`). Falls back to the code itself with a trailing space
 * (e.g. `"SEK "`) rather than a wrong symbol when the currency isn't one we
 * sell in; the space is the glyph's own separator, so callers concatenate it
 * directly against the value.
 */
export const currencySymbolFor = (currencyCode: string): string =>
  marketsData.find((data) => data.currencyCode === currencyCode)
    ?.currencySymbol ?? `${currencyCode} `

export const defaultMarketData = {
  market: "us",
  currencyCode: "USD",
  currencySymbol: "$",
  locale: "en",
  name: "United States",
} as MarketData
